module.exports = __webpack_public_path__ + "static/media/banner.3cb49931.jpg";